<template>
  <ul class="basket-desktop-tabs" :class="{ _mobile: isMobile }">
    <li v-for="button in buttons" :key="button.value" class="basket-desktop-tabs__item">
      <button
        class="basket-desktop-tabs__btn"
        :class="{ '_active': button.value === currentTab }"
        :disabled="button.value === currentTab"
        @click="handleChange(button.value)"
      >
        {{ button.name }}
      </button>
    </li>
  </ul>
</template>

<script>
import { computed, defineComponent } from '@vue/composition-api';

import { TABS_PAGE, BASKET_TAB_VALUE } from '@/enums';
import { checkMobile } from '@/utils/deviceCheck';

import useAuthorizations from '@/compositions/user/useAuthorizations';

export default defineComponent({
  name: 'TabsPage',
  props: {
    currentTab: { type: String, default: BASKET_TAB_VALUE },
  },
  setup(props, { emit }) {
    const { isAuthorized } = useAuthorizations();

    const isMobile = checkMobile();

    const handleChange = (type) => {
      if (type === props.currentTab) return;

      emit('changeTab', type);
    };

    const buttons = computed(() => TABS_PAGE.getElements(isAuthorized.value));

    return {
      isMobile,
      isAuthorized,
      buttons,
      handleChange,
    };
  },
});
</script>

<style lang="less">
.basket-desktop-tabs {
  .list-reset();

  position: relative;
  display: flex;

  &__item {
    margin-bottom: -1px;
  }

  &__btn {
    .button-reset();
    .h3-desktop();

    position: relative;
    border-bottom: 4px solid;
    border-color: transparent;
    padding: @size-x2 @size-x5;
    color: @link;
    transition: color @A;

    &._active {
      color: @black;
    }

    &:hover:not(:disabled),
    &._tap {
      color: @link-hover;
    }
  }

  &._mobile {
    padding: 0 @size-x4;
    justify-content: normal;
  }

  &._mobile &__btn {
    .p();

    padding-left: @size-x2;
    padding-right: @size-x2;
  }
}
</style>
